import './TableCommon.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import { emptyObject } from 'utils'
import useSyncScroll from 'utils/useSyncScroll'

import TableCommonHeader from './TableCommonHeader'
import TableCommonRow from './TableCommonRow'

const TableCommon = ({
  headerClassName,
  itemHeight,
  listHeight,
  maxRevenue,
  onFilter,
  onScroll,
  scrollOffset,
  shareData,
  showModal,
  sortBy,
  stores,
  structure,
  type,
  wrapperClass,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className={`table-common ${wrapperClass}`}>
      <TableCommonHeader className={headerClassName} structure={structure} onFilter={onFilter} sortBy={sortBy} type={type} />

      <List
        useIsScrolling
        className="table-common-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          maxRevenue,
          shareData,
          showModal,
          stores,
          structure,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {TableCommonRow}
      </List>
    </div>
  )
}

TableCommon.defaultProps = {
  shareData: emptyObject,
}

TableCommon.propTypes = {
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxRevenue: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  shareData: PropTypes.object,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  structure: PropTypes.array,
  type: PropTypes.string,
  wrapperClass: PropTypes.string.isRequired,
}

export default TableCommon
